/* globals WPDP */

import '../js/init'
import { init } from '../js/init-bootstrap'
import '../js/init-vue'
import * as erp from '../js/erp'

init()

//@ts-ignore
window.erp = erp

//@ts-ignore
console.log(`%cIniciando ERP%c${WPDP.VERSION}`,
  'color: white; background-color: #044a57; padding: 2px 5px;',
  'color: white; background-color: #1094a8; padding: 2px 5px;')
